export default "__VITE_ASSET__C$EDwg5N__"